(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(min-width: 750px)').matches) {
    return
  }

  const handleCollapse = (heading) => {
    if (heading.classList.contains('block-collapsed')) {
      heading.classList.remove('block-collapsed')
      heading.setAttribute('aria-expanded', 'true')
    } else {
      heading.classList.add('block-collapsed')
      heading.setAttribute('aria-expanded', 'false')
    }
  }
  
  document.querySelectorAll('.grid .footer-block__heading').forEach((heading, index) => {
    heading.classList.add('block-collapsed_new')
    heading.setAttribute('role', 'button')
    heading.setAttribute('aria-expanded', 'false')
    heading.setAttribute('tabindex', '1')

    heading.nextElementSibling.setAttribute('id', `footer-block-index-${index}`)
    heading.setAttribute('aria-controls', `footer-block-index-${index}`)

    heading.addEventListener('click', () => { handleCollapse(heading) })
    heading.addEventListener('keypress',  () => { handleCollapse(heading) })
  })

})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-grid-layout-sc"] && !Shopify.designMode) return;
  try {
    

 $(document).ready(function(){
  // Function to get the background color of the SVG
  function getSVGColor(index) {
    return $(".cls-1-" + index).css("fill");
  }

  // Click event for each hotspot
  $(".image-with-hotspot__hotspot-1, .image-with-hotspot__hotspot-2, .image-with-hotspot__hotspot-3, .image-with-hotspot__hotspot-4, .image-with-hotspot__hotspot-5").click(function(){
    var index = $(this).attr("class").match(/image-with-hotspot__hotspot-(\d+)/)[1];
    var bgColor = getSVGColor(index);

    // Set the background color of the specific hotspot button
    $(".overlay-" + index + " .hotspot.button").css("background-color", bgColor);

    // Add the 'show' class to the overlay
    $(".overlay-" + index).addClass("show");
  });

  // Click event for closing the overlay
  $(".sc-close-1, .sc-close-2, .sc-close-3, .sc-close-4, .sc-close-5").click(function(){
    var index = $(this).attr("class").match(/sc-close-(\d+)/)[1];

    // Remove the 'show' class from the overlay
    $(".overlay-" + index).removeClass("show");
  });
});




  
  $(document).ready(function(){
    $(".image-with-hotspot__hotspot-1").click(function(){
      $(".overlay-1").addClass("show");
    });
  });
  $(document).ready(function(){
    $(".image-with-hotspot__hotspot-2").click(function(){
      $(".overlay-2").addClass("show");
    });
  });
  $(document).ready(function(){
    $(".image-with-hotspot__hotspot-3").click(function(){
      $(".overlay-3").addClass("show");
    });
  });
  $(document).ready(function(){
    $(".image-with-hotspot__hotspot-4").click(function(){
      $(".overlay-4").addClass("show");
    });
  });
  $(document).ready(function(){
    $(".image-with-hotspot__hotspot-5").click(function(){
      $(".overlay-5").addClass("show");
    });
  });
  $(document).ready(function(){
    $(".sc-close-1").click(function(){
      $(".overlay-1").removeClass("show");
    });
  });
  $(document).ready(function(){
    $(".sc-close-2").click(function(){
      $(".overlay-2").removeClass("show");
    });
  });
  $(document).ready(function(){
    $(".sc-close-3").click(function(){
      $(".overlay-3").removeClass("show");
    });
  });
  $(document).ready(function(){
    $(".sc-close-4").click(function(){
      $(".overlay-4").removeClass("show");
    });
  });
  $(document).ready(function(){
    $(".sc-close-5").click(function(){
      $(".overlay-5").removeClass("show");
    });
  });



  

  } catch(e) { console.error(e); }
})();
})();
